'use client';

import { c as _c } from "react/compiler-runtime";
import { use } from 'react';
import WorldSection from '@/app/[locale]/(worlds)/components/WorldSection';
import { useUAContext } from '@/context/UAContext';
import { filterWorldsByDevice } from '@/lib/worlds';
import type { WorldCardLane } from '@/types/viverse-world-card';
type AllWorldsProps = {
  worldsPromise: Promise<WorldCardLane[]>;
};
function AllWorlds(t0) {
  const $ = _c(3);
  const {
    worldsPromise
  } = t0;
  const worlds = use(worldsPromise);
  const {
    deviceTypeWithAndroidAndIOS
  } = useUAContext();
  let t1;
  if ($[0] !== deviceTypeWithAndroidAndIOS || $[1] !== worlds) {
    const filteredWorlds = filterWorldsByDevice(worlds, deviceTypeWithAndroidAndIOS);
    t1 = filteredWorlds?.map(_temp);
    $[0] = deviceTypeWithAndroidAndIOS;
    $[1] = worlds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(world, index) {
  return <WorldSection key={world.id} index={index} world={world} />;
}
export default AllWorlds;